export default __webpack_public_path__ + "static/media/acrepair2.a39b0073.webp";